import React from 'react';
import WelcomeNavBar from './WelcomeNavBar';
import FooterSection from './Footersection';
import styles from './MarketingPageLayout.module.css';

export type MarketingNavVariant = 'welcome' | 'legacy';

export interface MarketingPageLayoutProps {
  children: React.ReactNode;
  /** `welcome` = fixed WelcomeNavBar (default). `legacy` = old NavBar for logged-in-only pages. */
  navVariant?: MarketingNavVariant;
}

const MarketingPageLayout: React.FC<MarketingPageLayoutProps> = ({
  children,
  navVariant = 'welcome',
}) => (
  <div className={styles.root}>
    {navVariant === 'welcome' ? <WelcomeNavBar /> : <WelcomeNavBar />}
    <main className={styles.main}>{children}</main>
    <FooterSection />
  </div>
);

export default MarketingPageLayout;
